export default $ => {

  let lastFbLoginContainerOver;
  let $fbErrorContainer;

  $('.eFbLoginButton').mouseenter(function() {
    lastFbLoginContainerOver = this;
  });

  window.onFacebookLogin = (data) => {
    if (data.status !== 'connected') {
      return;
    }

    const fbData = {
      uid: data.authResponse.userID,
      accessToken: data.authResponse.accessToken,
    };

    $.post(Routing.generate('facebook_login'), fbData, function(responseData) {
      if (responseData.success) {
        window.location = Routing.generate('homepage');
        return;
      }
      $('.cForm-Login__FbError').html('');
      $('.cForm-Login__FbError').hide();
      if (lastFbLoginContainerOver) {
        $fbErrorContainer = $(lastFbLoginContainerOver).find('.cForm-Login__FbError');
      } else {
        $fbErrorContainer = $('.cForm-Login__FbError');
      }
      $fbErrorContainer.html($('<p>').text(responseData.message));
      $fbErrorContainer.show();
    });
  };
};



// WEBPACK FOOTER //
// ./assets/js/component/facebook.js